<template>
  <div >

    <el-input
      v-model="string"
      @keydown.native.enter=''
      placeholder="搜索或定位.."

      remark="👆上面是自定义的,👇下面是固定的无需修改"

      size='mini' clearable style='margin-bottom:5px;' />

    <el-tree
      :data=' selectContact_data.data || [] '
      node-key='id'
      :expand-on-click-node="false"
      :default-expanded-keys="defaultKeys"
      :props='{
        children: "children",
        label: "name"
      }'
      @node-click=""
      
      remark="👆上面是自定义的,👇下面是固定的无需修改"

      ref='tree'
      highlight-current
      xnextick='!arguments[0] && (theOrganizationId = ""), $refs.tree0.filter(string), toSearch()'
      x:filter-node-method='((value,data)=>!value||data.organizationName.includes(value))'
      style=''
      v-s.height='H-192' />


  </div>
</template>

<script>
export default {
  name: 'MyTree',
  props: [ 'formobj', 'ruleobj'  ],
  data () {
    return {
      Myformobj: null,
      Myruleobj: null,
    }
  },
  created(){
    

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/$MyTree.vue